export default {
  header: {
    title: 'IdeIHM Instituto Hidrográfico de la Marina',
  },
  visor: {
    coordinates: 'Coordenadas',
    map: 'Mapa',
    image: 'Imagen',
    street_map: 'Callejero',
    base_layer: 'Capa base',
    marine: 'Marine-Geo',
    termycondition: 'Aviso Legal',
    about: 'Acerca de',
    portal: 'Ir al portal',
    extend: 'Zoom a la extensión del mapa',
    help: 'Manual de uso'
  },
};
